module.exports = __webpack_public_path__ + "bn.svg?c5b91605c852ec62583c5e7498a9f4c5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/bn.svg
// module id = 1265
// module chunks = 0